import { useEffect, useRef, useState } from 'react';
import { ProjectModel } from '../../../network/rest';
import { useSearchParams } from 'react-router-dom';
import { ProjectApi } from '../../../network';
import ApiErrorHandler from '../../../utils/ApiErrorHandler';
import { links, translations } from '../../../utils/staticContent';
import ListItemWithoutDescription from '../../components/ListItemWithoutDescription';
import Pagination from '../../components/Pagination';
import './style.scss';

function Projects() {
    const [data, setData] = useState<ProjectModel[]>([]);
    const [searchParams] = useSearchParams();
    const [dataCount, setDataCount] = useState(0);
    const [controller, setController] = useState({
        page: 0,
        rowsPerPage: 10,
    });

    async function getData() {
        try {
            const response = await ProjectApi.getProjectsApiV1ProjectsGet({
                offset: controller.page * controller.rowsPerPage,
                limit: controller.rowsPerPage,
                search: searchQuery || '',
            });
            if (response) {
                setData(response.projects);
                setDataCount(response.total);
            }
        } catch (e) {
            ApiErrorHandler(e, true);
        }
    }

    const searchQuery = searchParams.get('search');
    const previousSearchQuery = useRef(searchQuery);

    useEffect(() => {
        const isNewSearch = previousSearchQuery.current !== searchQuery;
        previousSearchQuery.current = searchQuery;

        // a new search invalidates the current offset, so go back to the first
        // page and let that controller change trigger the fetch
        if (isNewSearch && controller.page !== 0) {
            handlePageChange(0);
            return;
        }

        getData();
    }, [controller, searchQuery]);

    function handlePageChange(newPage: number) {
        setController({
            ...controller,
            page: newPage,
        });
    }

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
        setController({
            ...controller,
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0,
        });
    };

    return (
        <div className="Projects">
            <h1>{translations.projects}</h1>
            <div className="content-wrapper">
                {data.map((show, idx) => (
                    <ListItemWithoutDescription
                        key={`${show.id}${idx}`}
                        data={show}
                        url={links.projects}
                    />
                ))}
            </div>
            <Pagination
                page={controller.page}
                count={dataCount}
                rowsPerPage={controller.rowsPerPage}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </div>
    );
}

export default Projects;
